import { render, staticRenderFns } from "./BasicPageConfig.vue?vue&type=template&id=156eadce&scoped=true&"
import script from "./BasicPageConfig.vue?vue&type=script&lang=js&"
export * from "./BasicPageConfig.vue?vue&type=script&lang=js&"
import style0 from "./BasicPageConfig.vue?vue&type=style&index=0&id=156eadce&lang=css&scoped=true&"
import style1 from "./BasicPageConfig.vue?vue&type=style&index=1&id=156eadce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156eadce",
  null
  
)

export default component.exports